import { createStore } from '@souche-f2e/muji';
import { fetchPersonalOrder, createOrder, fetchOrderInfo } from '../services/order';
import { message } from 'antd';


const state = {
  itemPath: '我的工单',
  orderId: '',
  orderType: '',
  personalOrderList: [],
  routerType: '',
  orderInfo: {},
  isSubmited: false,
  page: 0
}

export default createStore({
  state,
  reducers: {
    UPDATE_ROUTE(state, payload) {
      return {
        ...state,
        ...payload
      }
    },
    UPDATE_LIST(state, personalOrderList) {
      return {
        ...state,
        personalOrderList
      }
    },
    UPDATE_ORDER(state, orderInfo) {
      return {
        ...state,
        orderInfo
      }
    }

  },
  effects: {
    updatePath(payload, { state, rootState }) { 
      this.UPDATE_ROUTE(payload)
    },
    async getList() {
      const body = await fetchPersonalOrder().promise;

      const { success, data } = body;

      
      if(success) {
        this.UPDATE_LIST(data);
      } else {
        
      }
    },
    async createOrder(payload, { state, rootState }) {
      const body = await createOrder(payload).promise;
      const { success, data } = body;
      if(success) {
        message.info('创建工单成功');
        this.UPDATE_ROUTE({
          isSubmited: true,
        })
      } else {
        message.error(`创建失败${data}`);
      }
    
    },
    async getOrder(id) {
      const body = await fetchOrderInfo(id).promise;
      const { success, data } = body;
      if(success) {
        this.UPDATE_ORDER(data);
      }
    },
    async clearSubmit() {
      this.updatePath({
        isSubmited: false,
      })
    }
  },
  async setup({ history }) {
    history.listen(route => {
      if (route.path === '/support/work_order') {
        const { orderId, create, notice} = route.query;
        let orderType;
        const routerType = (() => {
          if(orderId !== undefined) {
            this.getOrder(orderId);
            return 'order';
          } else if (create) {
            if (create === 'new') {
              return 'question';
            } else {
              orderType = create;
              if (notice) {
                return 'notice'
              } else {
                return 'create';
              }
            }
          } else {
            this.getList();
            return undefined;
          }
        })()
        this.updatePath({
          orderId: orderId !== undefined ? orderId : '',
          routerType: routerType !== undefined ? routerType : '',
          orderType: orderType !== undefined ? orderType : '',
        });
      }
    })
  },
});